import { texts } from '../../../../../../constants/texts';

export const modes = {
  houses: 'houses',
  tenants: 'tenants',
  accounts: 'accounts',
  flats: 'flats',
};

export const placeholders = {
  [modes.houses]: texts.searchByAddress,
  [modes.tenants]: texts.searchByNamePhoneEmail,
  [modes.accounts]: texts.searchByAccountNumber,
  [modes.flats]: texts.seacrhByFlatNumber,
};
